<template>
    <v-container v-if="user" class="mx-2 d-flex align-items-center">
        <v-row justify="center">
            <v-menu bottom min-width="240px" offset-y>
                <template #activator="{ on }">
                    <v-btn icon style="width: 36px; height: 36px" v-on="on">
                        <v-avatar color="#e0e0e0" size="36">
                            <span v-if="!user.avatar">{{ initials }}</span>
                            <img v-if="user.avatar" :src="user.avatar" :alt="user.name" />
                        </v-avatar>
                    </v-btn>
                </template>

                <v-card>
                    <v-list flat class="avatar-list">
                        <v-list-item-group :color="color">
                            <v-list-item v-if="impersonate" @click="stopImpersonateUrl()">
                                <v-list-item-icon class="m-0">
                                    <v-icon left>mdi mdi-account-remove-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ t('default::button.stop-impersonate') }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item @click="gotToProfile(user)">
                                <v-list-item-icon class="m-0">
                                    <v-icon left>mdi-account</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ user.name }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="my-1 mx-4"></v-divider>
                            <b-confirm :text="t('default::logout.confirmation')" @true="goTo('auth.logout')">
                                <template #button="{ on, logoutDialog }">
                                    <v-list-item @click="logoutDialog = true" v-on="on">
                                        <v-list-item-icon class="m-0">
                                            <v-icon left>mdi-logout-variant</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ t('default::button.logout') }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </b-confirm>
                        </v-list-item-group>
                    </v-list>
                    <!-- <v-list-item-content class="justify-center">
                        <div class="mx-auto text-center">
                            <v-avatar :color="color" class="mb-4">
                                <span v-if="!user.avatar" class="white--text headline">{{ initials }}</span>
                                <img v-if="user.avatar" :src="user.avatar" :alt="user.name" />
                            </v-avatar>
                            <h6>{{ user.name }}</h6>
                            <theme-changer></theme-changer>
                            <v-divider class="my-3"></v-divider>
                            <v-btn
                                depressed
                                rounded
                                text
                                @click="
                                    !!user.is_dms_user
                                        ? goTo('dms-users.profile')
                                        : goTo('users.get', { user: user.id })
                                "
                            >
                                Edit Account
                            </v-btn>
                            <v-divider class="my-3"></v-divider>
                            <b-confirm :text="t('default::logout.confirmation')" @true="goTo('auth.logout')">
                                <template #button="{ on, logoutDialog }">
                                    <v-btn
                                        style="text-transform: none"
                                        depressed
                                        rounded
                                        text
                                        @click="logoutDialog = true"
                                        v-on="on"
                                    >
                                        {{ t('default::button.logout') }}
                                    </v-btn>
                                </template>
                            </b-confirm>
                        </div>
                    </v-list-item-content> -->
                </v-card>
            </v-menu>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'AvatarComponent',
    components: {},
    props: {
        impersonate: {
            type: String,
            required: false,
            default: '0',
        },
    },
    data() {
        return {
            user: null,
            initials: null,
            color: null,
            items: [
                { text: 'Real-Time', icon: 'mdi-clock' },
                { text: 'Audience', icon: 'mdi-account' },
                { text: 'Conversions', icon: 'mdi-flag' },
            ],
        };
    },
    computed: {
        profile() {
            return this.$store.state.user.profile;
        },
    },
    watch: {
        profile(newUser, oldUser) {
            if (oldUser !== newUser) {
                this.user = newUser;
                this.initials = this.$root.makeInitials(newUser.name);
            }
        },
    },
    created() {
        this.color = 'secondary';
    },
    methods: {
        gotToProfile(user) {
            if (user.is_dms_user) {
                return this.goTo('dms-users.profile');
            }
            return this.goTo('users.get', { user: user.id });
        },
        goTo(route, param = null) {
            window.localStorage.clear();
            if (param) {
                this.$root.goTo(this.$root.route(route, param ? param : false));
            }
            if (!param) {
                this.$root.goTo(this.$root.route(route));
            }
        },
        stopImpersonateUrl() {
            return this.$root.goTo(route('auth.stop-impersonate'));
        },
    },
};
</script>

<style lang="scss" scoped>
.avatar-list {
    .v-item-group {
        .v-list-item {
            .v-list-item__icon {
                .v-icon {
                }
            }
        }
    }
}
</style>
